module.exports = __webpack_public_path__ + "img/unicom.6ad3a0fc.png";